module.exports = __webpack_public_path__ + "static/media/55_tn.7e5e2d98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/55_tn.jpg
// module id = 543
// module chunks = 0